import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {Globals} from '../../../../core/services/globals';
import {AbstractListingsSearchComponent} from '../../../../shared/components/listing-search/abstract-listings-search.component';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'my-muskoka-listing-search',
  templateUrl: './muskoka-listing-search.component.html',
  styleUrls: ['../../../../shared/components/listing-search/listing-search.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule], // ✅ Add FormsModule here
})
export class MuskokaListingsSearchComponent extends AbstractListingsSearchComponent {
  constructor(router: Router, globals: Globals) {
    super(router, globals);
  }

  /**
   * Provide Muskoka-specific default areas.
   */
  protected getDefaultAreas(): { name: string; value: string }[] {
    return [
      {name: 'Lake Muskoka', value: 'LAKE_MUSKOKA'},
      {name: 'Lake Rosseau', value: 'LAKE_ROSSEAU'},
      {name: 'Lake Joseph', value: 'LAKE_JOSEPH'},
      {name: 'Lake Of Bays', value: 'LAKE_OF_BAYS'},
      {name: 'Smaller quiet Lakes', value: 'SMALLER_QUIET_LAKES'},
      {name: 'Lake Mary', value: 'LAKE_MARY'},
      {name: 'Huntsville', value: 'HUNTSVILLE'},
      {name: 'Bracebridge', value: 'BRACEBRIDGE'},
      {name: 'Gravenhurst', value: 'GRAVENHURST'},
      {name: 'Bala', value: 'BALA'},
      {name: 'Port Carling', value: 'PORT_CARLING'},
      {name: 'Georgian Bay', value: 'GEORGIAN_BAY'},
    ];
  }
}
